import { PageContextType } from '../../types';

const supportedPageContextTypes = [PageContextType.CONFLUENCE_PAGE_VIEW];

// this is based purely on the page context type
export const isPageContextTypeSupportedForRankedActions = (
	pageContextType: PageContextType,
): boolean => {
	return supportedPageContextTypes.includes(pageContextType);
};
